module.exports = __webpack_public_path__ + "static/any-do-bb9d7c31ac82ee9773a6c85fe3da07a9.svg";